module.exports = __webpack_public_path__ + "static/media/4.9a76e74e.svg";